import { Helmet } from 'react-helmet-async';
import { AgGridReact } from 'ag-grid-react';
import { useState, useEffect, useRef } from 'react';
import { enqueueSnackbar } from 'notistack';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import axiosInstance from '../../utils/axios';
import EditIconButton from '../../reuseable-components/DefaultButtons/EditIconButton';
import DeleteIconButton from '../../reuseable-components/DefaultButtons/DeleteIconButton';
import ProductCategoryForm from './ProductCategoryForm';
import Iconify from '../../reuseable-components/iconify/Iconify';
import AgGridDefaults from '../../reuseable-components/AGGrid/AGGridDefaults';
import AGGridQuickFilterWrapper from '../../reuseable-components/AGGrid/AGGridQuickFilterWrapper';

export default function ProductCategoryList() {
  const gridRef = useRef(null);

  const [productCategories, setProductCategories] = useState([]);
  const [editProductCategory, setEditProductCategory] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axiosInstance.get("/productCategory/productCategories")
      .then(res => setProductCategories(res.data))
      .catch(() => enqueueSnackbar('Product category list failed', { variant: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  const deleteProductCategory = (id) => {
    axiosInstance.post(`/productCategory/deleteProductCategory?id=${id}`)
      .then(() => {
        setProductCategories(productCategories => [...productCategories.filter(productCategory => productCategory.id !== id)]);
        enqueueSnackbar('Product category deleted', { variant: 'success' })
      })
      .catch(() => enqueueSnackbar('Product category delete failed', { variant: 'error' }))
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      cellRenderer: (params) => <Stack direction="row" spacing={1}>
        <EditIconButton onClick={() => { setEditProductCategory(params.data); setOpenForm(true); }} />
        <DeleteIconButton content={`Are you sure you want to delete ${params.data.name}?`} action={() => deleteProductCategory(params.data.id)} />
      </Stack>
    }
  ];

  return (<>
    <Helmet>
      <title>Product Category List | NHIDirect</title>
    </Helmet>

    <Box sx={{ height: "calc(100% - 55px)", mt: 2 }}>
      <AGGridQuickFilterWrapper gridRef={gridRef}>
        <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => { setEditProductCategory(null); setOpenForm(true); }} color="primary" size="small">
          <Typography>Add Product Category</Typography>
        </Button>
      </AGGridQuickFilterWrapper>
      {!loading ? <Box sx={{ height: "max(500px, 100%)" }}>
        <AgGridReact ref={gridRef} {...AgGridDefaults} columnDefs={columns} rowData={productCategories} loading={loading} />
      </Box> : <Box sx={{ display: "flex", justifyContent: "center", m: 3 }}><CircularProgress /></Box>}
      <ProductCategoryForm editProductCategory={editProductCategory} open={openForm} close={() => { setEditProductCategory(null); setOpenForm(false); }}
        setProductCategories={setProductCategories} />
    </Box>
  </>);
}